import type { SVGProps } from "react";
import * as React from "react";

interface RatingStarProps extends SVGProps<SVGSVGElement> {
  fillPercentage: number;
  clipPathId?: string;
}

export const RatingStar: React.FC<RatingStarProps> = ({
  fillPercentage,
  clipPathId,
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      {...props}
    >
      <defs>
        <linearGradient
          id="gradientFill"
          x1={26.431}
          x2={6.068}
          y1={-7.735}
          y2={31.538}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFDD64" />
          <stop offset={1} stopColor="#FFA620" />
        </linearGradient>

        <clipPath id={clipPathId}>
          <rect width={`${fillPercentage}%`} height="100%" />
        </clipPath>
      </defs>

      <path
        fill="#28282D"
        d="M14.367.249a.5.5 0 0 1 .856 0l4.73 7.858a.5.5 0 0 0 .315.23l8.935 2.068a.5.5 0 0 1 .264.815l-6.012 6.926a.5.5 0 0 0-.12.371l.793 9.137a.5.5 0 0 1-.693.503L14.99 24.58a.5.5 0 0 0-.39 0l-8.444 3.577a.5.5 0 0 1-.694-.503l.793-9.137a.5.5 0 0 0-.12-.371L.123 11.22a.5.5 0 0 1 .265-.815l8.934-2.069a.5.5 0 0 0 .316-.23z"
      />

      <path
        fill="url(#gradientFill)"
        clipPath={`url(#${clipPathId})`}
        d="M14.367.249a.5.5 0 0 1 .856 0l4.73 7.858a.5.5 0 0 0 .315.23l8.935 2.068a.5.5 0 0 1 .264.815l-6.012 6.926a.5.5 0 0 0-.12.371l.793 9.137a.5.5 0 0 1-.693.503L14.99 24.58a.5.5 0 0 0-.39 0l-8.444 3.577a.5.5 0 0 1-.694-.503l.793-9.137a.5.5 0 0 0-.12-.371L.123 11.22a.5.5 0 0 1 .265-.815l8.934-2.069a.5.5 0 0 0 .316-.23z"
      />
    </svg>
  );
};
